// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import ClaimDebitFields from './claim-debit-fields';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import {FormattedMessage} from 'react-intl';
import FullDebitModal from '../../shared/components/debit-modal';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {isNotEmpty} from '../../../claim/shared/services/claim-shared-helper';

function handleDebit() {

    this.actions.handleDebit(this.claimNumber.trim(), this.debitType.key, this.debitTypes);

}

function handleFullDebitModalClose() {

    this.actions.updateFullDebitModalVisibility(false);

}

function handleFullDebitCommentsChange(comments) {

    this.actions.updateFullDebitComments(comments);

}

function handleFullDebitModalConfirmation(debit) {

    this.actions.submitFullDebit(debit);

}

function handleDebitTypeChange(event) {

    this.actions.updateDebitType(event.target.value, this.debitTypes);

}

function handleConfirmationModalClose() {

    this.actions.updateConfirmationModalVisibility(false);

}

function onConfirm() {

    const endPoint = 'https://dlrdoc.deere.com/ag_cust_supp/claimDebit';

    window.open(endPoint, '_blank');

    this.actions.updateConfirmationModalVisibility(false);

}

class ClaimDebit extends Component {

    componentWillMount() {

        this.props.actions.readDebitTypes();

    }

    componentWillUnmount() {

        this.props.actions.resetClaimDebit();

    }

    render() {

        return (
            <section className='claim-debit'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <ClaimDebitFields
                    claimNumber={this.props.claimNumber}
                    debitType={this.props.debitType}
                    debitTypes={this.props.debitTypes}
                    onClaimNumberChange={this.props.actions.updateClaimNumber}
                    onDebitTypeChange={this.props::handleDebitTypeChange}
                />
                <div className='button-group'>
                    <button
                        className='primary'
                        disabled={!(this.props.debitType.key && isNotEmpty(this.props.claimNumber))}
                        onClick={this.props::handleDebit}
                    >
                        <FormattedMessage id='DEBIT'/>
                    </button>
                </div>
                <FullDebitModal
                    busyCounter={this.props.busyCounter}
                    closeModal={this.props::handleFullDebitModalClose}
                    debit={this.props.debit}
                    debitType='FULL'
                    isModalVisible={this.props.isFullDebitModalVisible}
                    onCommentsChange={this.props::handleFullDebitCommentsChange}
                    onConfirmation={this.props::handleFullDebitModalConfirmation}
                />
                <ConfirmationModal
                    confirmMessage='DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS'
                    isOpen={this.props.isConfirmationModalVisible}
                    onClose={this.props::handleConfirmationModalClose}
                    onConfirm={this.props::onConfirm}
                    title='FULL_DEBIT'
                />
            </section>
        );

    }

}

ClaimDebit.displayName = 'ClaimDebit';
ClaimDebit.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    claimNumber: PropTypes.string.isRequired,
    debit: PropTypes.instanceOf(Debit).isRequired,
    debitType: PropTypes.instanceOf(KeyValuePair).isRequired,
    debitTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    isConfirmationModalVisible: PropTypes.bool.isRequired,
    isFullDebitModalVisible: PropTypes.bool.isRequired
};

export default ClaimDebit;



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/components/claim-debit.js